/**
 * 取得顯示規格
 * @param {array} specList 規格列表
 * @param {string} separator 分隔符號
 * @param {function} filterFunc 過濾規格選項
 */
export const getDisplaySpec = (specList, separator = ', ', filterFunc = (opt) => opt.isOption === 1) => {
  let displaySpec = ''
  const selectedSpecOptions = specList.flatMap(spec => {
    return spec.children.filter(filterFunc)
  })
  if (selectedSpecOptions.length > 0) {
    displaySpec += selectedSpecOptions.map(opt => opt.name).join(separator)
  }
  return displaySpec
}
